import {
  AccordionItem as ChakraAccordionItem,
  AccordionPanel,
  AccordionButton,
  HStack,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';

export const AccordionItem: React.FC<{
  panel: React.ReactNode;
  title: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}> = ({ panel, title, onClick }) => {
  return (
    <ChakraAccordionItem
      onClick={onClick}
      borderWidth="1px"
      borderStyle="solid"
      borderColor="gray.200"
      borderRadius="8px"
      m="16px 0"
      p="16px"
    >
      {({ isExpanded }) => (
        <>
          <AccordionButton alignSelf="flex-start" w="100%">
            <HStack w="100%" justifyContent="space-between">
              <Text fontWeight="bold" size="large">
                {title}
              </Text>
              {isExpanded ? (
                <Icon
                  icon="circle-chevron-up"
                  color={colors.aurora[500]}
                  key="circle-chevron-up"
                />
              ) : (
                <Icon icon="circle-chevron-down" key="circle-chevron-down" />
              )}
            </HStack>
          </AccordionButton>
          <AccordionPanel>{panel}</AccordionPanel>
        </>
      )}
    </ChakraAccordionItem>
  );
};
